import { StepConfig } from './types';
import { FORM_FIELDS, FORM_STEPS, PAGE } from '../../../constants';
import { Briefcase, IdentityCard, UserProfile, Wallet } from '@sravni/react-icons';
import { schema as paramsSchema, ParamsStepSheetView, ParamsStepView } from './steps/params';
import { PassportStepSheetView, schema as passportSchema, PassportStepView } from './steps/passport';
import { PersonalDataStepView, schema as personalDataSchema, PersonalDataStepSheetView } from './steps/personal.data';
import { onNext as paramsStepOnNext } from '../steps/params';
import { onNext as personalDataStepOnNext } from '../steps/passport';
import { schema as workSchema, WorkStepSheetView, WorkStepView } from './steps/work';
import { onNext as workStepNext } from '../steps/work';
import { getStore } from '../../../store/client';
import analytics from '../../../helpers/analytics';

export const passportStepOnNext = async () => {
    const { withoutAnalytics, page } = getStore().getState().formStore;

    if (!withoutAnalytics) {
        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: [PAGE.CARDS_RESTORE].includes(page as any)
                ? analytics.categories.CreditCard
                : analytics.categories.Loan,
            eventAction: 'Шаг 2|Паспорт',
        });
    }

    return true;
};

export const stepsConfig: Array<StepConfig> = [
    {
        View: ParamsStepView,
        SheetView: ParamsStepSheetView,
        stepName: FORM_STEPS.PARAMS,
        title: 'Параметры кредита',
        icon: <Wallet />,
        schema: paramsSchema,
        onStepNext: paramsStepOnNext,
        ignoringFocusFields: [FORM_FIELDS.REGION, FORM_FIELDS.AUTO_MODEL, FORM_FIELDS.AUTO_BRAND],
    },
    {
        View: PassportStepView,
        SheetView: PassportStepSheetView,
        stepName: FORM_STEPS.PASSPORT,
        title: 'Паспорт',
        icon: <IdentityCard />,
        schema: passportSchema,
        onStepNext: passportStepOnNext,
        ignoringFocusFields: [FORM_FIELDS.FULL_NAME, FORM_FIELDS.UNIT_CODE],
    },
    {
        View: PersonalDataStepView,
        SheetView: PersonalDataStepSheetView,
        stepName: FORM_STEPS.PERSONAL_DATA,
        title: 'Личные данные',
        icon: <UserProfile />,
        schema: personalDataSchema,
        onStepNext: personalDataStepOnNext,
        ignoringSheetViewFields: [FORM_FIELDS.RESIDENCE_SAME_REGISTRATION],
        ignoringFocusFields: [FORM_FIELDS.REGISTRATION_STREET, FORM_FIELDS.RESIDENCE_STREET],
    },
    {
        View: WorkStepView,
        SheetView: WorkStepSheetView,
        stepName: FORM_STEPS.WORK,
        title: 'Место работы',
        icon: <Briefcase />,
        schema: workSchema,
        onStepNext: workStepNext,
        ignoringFocusFields: [FORM_FIELDS.ORGANIZATION_NAME, FORM_FIELDS.WORK_ADDRESS],
        submitBtnText: 'Перейти к предложениям',
    },
];
